<template>
  <div>
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div
        class="mt-6 flex items-center justify-between px-6"
        v-if="productSpecs"
      >
        <div class="flex items-center" v-if="venue">
          <img width="40" :src="venue.logoUrl" class="mr-4" />
          <div>
            <h4>Assign recipe to venue</h4>
            <small>assigning to {{ venue.venueName }} </small>
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Select product spec</span>
            </div>
            <div>
              <vs-select
                v-model="productSpec"
                placeholder="Filter by pouring category"
              >
                <vs-select-item
                  :key="item.id"
                  :value="item.id"
                  :text="item.name"
                  v-for="item in productSpecs"
                />
              </vs-select>
              <div v-if="productSpecDetails" class="my-4 flex items-center">
                <img
                  :src="productSpecDetails.imageUrl"
                  height="80"
                  class="rounded-lg"
                />
                <div class="ml-2">
                  <b>{{ productSpecDetails.name }}</b>
                </div>
              </div>
              <vs-button class="mt-3" color="success" @click="confirmAssign">
                Assign
              </vs-button>
            </div>
          </div>

          <!--  -->
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="closeSidebar"> Go back </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/shout-icon.png";
import { mapGetters } from "vuex";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  components: {
    VenueSelector,
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      productSpec: null,

      venue: null,
    };
  },
  computed: {
    ...mapGetters({
      activeCountry: "venues/activeCountry",
      productSpecs: "productSpecs/productSpecs",
    }),
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },

    productSpecDetails() {
      return this.productSpecs.find((x) => x.id == this.productSpec);
    },
  },
  methods: {
    closeSidebar() {
      this.isActive = false;
      this.isLoading = false;
    },
    async showEmpty(venue) {
      this.isActive = true;
      this.isLoading = true;

      this.venue = venue;
      console.log("venue is ", venue);
      var result = await this.$store.dispatch("productSpecs/getProductSpecs");

      this.isLoading = false;
    },

    async confirmAssign() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Assign this recipe to the venue?`,
        accept: this.assign,
      });
    },
    async assign() {
      console.log("Assigning DTO", this.productSpec, this.venue.venueId);

      const dto = {
        productSpecIds: [this.productSpec],
      };

      try {
        const result = await this.$store.dispatch(
          "pimVenues/assignProductSpec",
          {
            venueId: this.venue.venueId,
            dto: dto,
          }
        );

        this.$vs.notify({
          title: "Recipe assigned",
          text: "Product recipe successfully assigned to venue.",
        });

        await this.$store.dispatch(
          "pimVenues/getVenueProductSpecs",
          this.venue.venueId
        );

        this.isActive = false;
        this.isLoading = false;
      } catch (err) {
        console.log("Error assigning recipe", err);
        this.$vs.notify({
          color: "danger",
          time: 4000,
          title: "Error assigning recipe",
          text: "Error assigning recipe to venue.",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>